export default __webpack_public_path__ + "static/media/facebook_social.d1dc4a7f.svg";